import React, { Suspense } from 'react';
import { RelayErrorBoundary } from '../error-boundary/RelayErrorBoundary';

export const RelaySuspensefulBoundary = ({
	children,
	fallback = null,
	errorFallback = null,
}: {
	children: React.ReactNode;
	errorFallback?: React.ReactNode;
	fallback?: React.ReactNode;
}): React.JSX.Element => (
	<RelayErrorBoundary fallback={errorFallback}>
		<Suspense fallback={fallback}>{children}</Suspense>
	</RelayErrorBoundary>
);
